module.exports = __webpack_public_path__ + "static/media/Covert_Fullday.fbcf3c2f.mp3";